// externals
import { RSAA } from 'redux-api-middleware';

// libraries
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

// action types
import {
    GET_LENDER_DECISIONS,
    GET_LENDER_DECISIONS_FAILURE,
    GET_LENDER_DECISIONS_SUCCESS,
    LENDER_DECISIONS_REQUEST_SKIPPED
} from '../actionTypes/fullLenderDecisionsActionTypes';

// selectors
import { getCreditAppReferenceId } from '../selectors/creditAppSelectors';
import { getDealRefId as getFsDealRefId } from '../selectors/offerSelectors';

// types
import { getDealRefIdFS } from '../selectors/offerRedux';
import type { DashStoreThunk } from '../types/appState';

export const fetchLenderDecisions = (): DashStoreThunk => (dispatch, getState) => {
    const state = getState();
    const creditAppId = getCreditAppReferenceId(state);
    const dealRefIdFS = getDealRefIdFS(state); // deal_ref_id
    const fsDealRefId = getFsDealRefId(state); // fsDealRefId

    const dealRefId = fsDealRefId || dealRefIdFS;

    const isR1Dealer = dealerSelectors.isCreditProviderRouteOne(state);
    const sourcePartnerDealerId = isR1Dealer
        ? dealerSelectors.getRouteOnePartyId(state)
        : dealerSelectors.getPartnerDealerId(state);

    if (!creditAppId || !dealRefId || !sourcePartnerDealerId) {
        const params = { creditAppId, dealRefId, sourcePartnerDealerId };
        const reason = 'invalidRequestParameters';

        logNewRelicPageAction('MV:Lender Decisions', { type: reason, ...params });

        return dispatch({
            type: LENDER_DECISIONS_REQUEST_SKIPPED,
            payload: { reason, params }
        });
    }

    const locHref = locHrefUtil.getLocHref();
    const endpoint = `full-lender-decision/${dealRefId}/partner-dealers/${sourcePartnerDealerId}/credit-apps/${creditAppId}`;
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, endpoint);

    return dispatch({
        [RSAA]: {
            endpoint: bffApiUrlResult.url,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            types: [GET_LENDER_DECISIONS, GET_LENDER_DECISIONS_SUCCESS, GET_LENDER_DECISIONS_FAILURE]
        }
    });
};
